module.exports = __webpack_public_path__ + "static/media/2.cff1fc0f.png";